import { createRouter, createWebHistory } from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const Financial = () => import(/* webpackChunkName: "financial" */ '../views/Financial.vue')
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const Credits = () => import(/* webpackChunkName: "credits" */ '../views/Credits.vue')
const Contact = () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
const Organization = () => import(/* webpackChunkName: "organization" */ '../components/Organization.vue')
const ProductRates = () => import(/* webpackChunkName: "productrates" */ '../components/ProductRates.vue')
const Complaints = () => import(/* webpackChunkName: "complaints" */ '../components/Complaints.vue')
const Education = () => import(/* webpackChunkName: "education" */ '../components/Education.vue')

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/financial', name: 'financial', component: Financial },
  { path: '/about', name: 'about', component: About },
  { path: '/credits', name: 'credits', component: Credits },
  { path: '/credits/:type', name: 'credits-type', component: Credits, props: true },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/organization', name: 'organization', component: Organization },
  { path: '/productrates', name: 'productrates', component: ProductRates },
  { path: '/complaints', name: 'complaints', component: Complaints },
  { path: '/education', name: 'education', component: Education },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
